import React from "react";
import { Paperclip } from "lucide-react";
import {
  hasAttachedDocument,
  getDocumentUrl,
} from "../../utils/tenderFormatters";

// Attached-document indicator (paperclip). Renders only when the tender has a
// document, and opens the SAME url the preview modal uses (getDocumentUrl) in
// a new tab — identical behaviour on the card and in the list row. Shared so
// card + list never diverge. `stopPropagation` so it doesn't toggle a row.
const AttachedDocLink = ({ tender, size = 5 }) => {
  if (!hasAttachedDocument(tender)) return null;
  const docUrl = getDocumentUrl(tender);
  const dim = size === 4 ? "w-4 h-4" : "w-5 h-5";
  return (
    <a
      href={docUrl}
      target="_blank"
      rel="noopener noreferrer"
      onClick={(e) => e.stopPropagation()}
      className="p-1.5 hover:bg-gray-100 rounded-lg transition-colors inline-flex items-center"
      aria-label="Open attached document"
      title="Attached document"
    >
      <Paperclip className={`${dim} text-[#535370]`} />
    </a>
  );
};

export default AttachedDocLink;
